import { createContext } from 'react';
/**
 * Context to access MSRC's preconfigured analytics provider.
 */
export const AnalyticsContext = createContext({});
